import React, {Component, createRef} from 'react';
import { connect } from 'react-redux';
// import { useLocation } from 'react-router-dom';


import Aux from '../Auxx/Auxx';
import classes from './Layout.module.css';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import HelpDrawer from '../../components/Navigation/HelpDrawer/HelpDrawer';
import UserDrawer from '../../components/Navigation/UserDrawer/UserDrawer';
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer';
import * as actionTypes from "../../store/actions/actionTypes";
import UpdatedUserProfile from "../../components/UserProfile/UpdatedUserProfile/UpdatedUserProfile";
import PresetModal from "../../components/UI/Modal/PresetModal/PresetModal";
import Auth from "../../containers/Auth/Auth";
import MiscSearchPanel from "../../components/MIscSearchPanel/MiscSearchPanel";
import NotificationPanel from "../../components/NotificationPanel/NotificationPanel";
import TopDrawer from "../../components/UI/TopDrawer/TopDrawer";
import MergeSelectionModal from "../../components/Merging/MergeSelectionModal/MergeSelectionModal";

class Layout extends Component {
    state = {
        showHelpDrawer: false,
        showUserDrawer: false,
        showSideDrawer: false,
        showNotificationsDrawer: false
    };

    loginRef = createRef()
    miscSearchRef = createRef()
    // notificationsRef = createRef()

    helpDrawerClosedHandler = () => {
        this.setState( { showHelpDrawer: false } );
    };

    helpDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showHelpDrawer: !prevState.showHelpDrawer, showNotificationsDrawer: false };
        } );
    };

    sideDrawerClosedHandler = () => {
        this.setState( { showSideDrawer: false } );
    };

    sideDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showSideDrawer: !prevState.showSideDrawer};
        } );
    };

    notificationDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showNotificationsDrawer: !prevState.showNotificationsDrawer, showHelpDrawer: false  };
        } );
    };

    notificationDrawerCloseHandler = () => {
        this.setState({ showNotificationsDrawer: false })
    };

    userDrawerClosedHandler = () => {
        this.setState( { showUserDrawer: false } );
    };

    userDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showUserDrawer: !prevState.showUserDrawer };
        } );
    };

    toggleSearchHandler = () => {
        this.props.onToggleSearch();
    };

    toggleGamesSearchHandler = () => {
        this.props.onToggleGamesSearch();
    };

    render () {

        return (
            <Aux>
                <Toolbar
                    isAuth={this.props.isAuthenticated}
                    userId={this.props.userId}
                    accountId={this.props.accountId}
                    userPermissions={this.props.userPermissions}
                    notifications={this.props.notifications}
                    onSelectedUserId={this.props.onSelectedUserId}
                    helpDrawerClosed={this.helpDrawerClosedHandler}
                    helpDrawerToggleClicked={this.helpDrawerToggleHandler}
                    userDrawerToggleClicked={this.userDrawerToggleHandler}
                    sideDrawerToggleClicked={this.sideDrawerToggleHandler}
                    sideDrawerClosed={this.sideDrawerClosedHandler}
                    toggleSearch={this.toggleSearchHandler}
                    toggleGamesSearch={this.toggleGamesSearchHandler}
                    selectedPattern={this.props.selectedPattern}
                    userEditOpen={this.props.userEditOpen}
                    location={this.props.location.pathname}
                    openLogin={() => this.loginRef.current.open()}
                    openMiscSearch={() => this.miscSearchRef.current.open()}
                    openNotifications={this.notificationDrawerToggleHandler}
                    token={this.props.token}
                />
                {/*<HelpDrawer*/}
                {/*    open={this.state.showHelpDrawer}*/}
                {/*    closed={this.helpDrawerClosedHandler}*/}
                {/*/>*/}
                <SideDrawer
                    isAuth={this.props.isAuthenticated}
                    userId={this.props.userId}
                    accountId={this.props.accountId}
                    open={this.state.showSideDrawer}
                    userPermissions={this.props.userPermissions}
                    notifications={this.props.notifications}
                    onSelectedUserId={this.props.onSelectedUserId}
                    helpDrawerClosed={this.helpDrawerClosedHandler}
                    helpDrawerToggleClicked={this.helpDrawerToggleHandler}
                    userDrawerToggleClicked={this.userDrawerToggleHandler}
                    sideDrawerToggleClicked={this.sideDrawerToggleHandler}
                    sideDrawerClosed={this.sideDrawerClosedHandler}
                    toggleSearch={this.toggleSearchHandler}
                    toggleGamesSearch={this.toggleGamesSearchHandler}
                    selectedPattern={this.props.selectedPattern}
                    userEditOpen={this.props.userEditOpen}
                    location={this.props.location.pathname}
                    openLogin={() => this.loginRef.current.open()}
                    openMiscSearch={() => this.miscSearchRef.current.open()}
                    openNotifications={this.notificationDrawerToggleHandler}
                    token={this.props.token}
                />
                <UserDrawer
                    isAuth={this.props.isAuthenticated}
                    open={this.state.showUserDrawer}
                    closed={this.userDrawerClosedHandler}
                    toggleSearch={this.toggleSearchHandler}
                    toggleGamesSearch={this.toggleGamesSearchHandler}
                />
                <UpdatedUserProfile givePermissions={this.props.userPermissions.give_permissions}/>
                <main className={classes.Content}>
                    {this.props.children}
                </main>
                <PresetModal ref={this.loginRef}><Auth shouldRedirect hideDragon/></PresetModal>
                <TopDrawer style={{maxWidth: "100%"}} open={this.state.showNotificationsDrawer} anyTopDrawerOpen={this.state.showHelpDrawer || this.state.showNotificationsDrawer} onClose={this.notificationDrawerCloseHandler}><NotificationPanel /></TopDrawer>
                <TopDrawer style={{maxWidth: "100%"}} open={this.state.showHelpDrawer} anyTopDrawerOpen={this.state.showHelpDrawer || this.state.showNotificationsDrawer} onClose={this.helpDrawerClosedHandler}><HelpDrawer /></TopDrawer>
                <MiscSearchPanel userId={this.props.userId} accountId={this.props.accountId} userPermissions={this.props.userPermissions}/>
                <MergeSelectionModal/>
            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        isAuthenticated:  state.auth.token !== null,
        userId: state.auth.userId,
        accountId: state.auth.accountId,
        // selectedPattern: state.patternLibrary.selectedPattern.id,
        search_panel_active: state.patternLibrary.search_panel_active,
        userEditOpen: state.userSidebar.editUser,
        userPermissions: state.auth.userPermissions,
        notifications: state.auth.notifications
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onToggleSearch: () => dispatch({ type: actionTypes.SEARCH_TOGGLE}),
        onToggleGamesSearch: () => dispatch({ type: actionTypes.SEARCH_GAMES_TOGGLE})
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Layout );